import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import Image from "next/image";
import renderHTML from "lib/render-html";
import FormDialog from "components/custom/FormDialog";
import DownloadBrochureForm from "components/forms/DownloadBrochureForm";
import { Link } from "react-scroll";
import { TOOL_BAR_HEIGHT } from "lib/settings";
import Breadcrumbs from "components/common/Breadcrumbs";
import OgImage from "components/common/OgImage";
const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    heading: {
      fontWeight: 500,
      "& span": {
        fontSize: 18,
        fontWeight: 400,
      },
    },
    heroImage: {
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    requestButton: {
      marginLeft: theme.spacing(3),
      [theme.breakpoints.down("xs")]: {
        marginLeft: theme.spacing(0),
        marginTop: theme.spacing(2),
      },
    },
    logoList: {
      margin: 0,
      marginTop: "5px",
      padding: 0,
      listStyle: "none",
      display: "inline-flex",
      columnGap: 8,
      "& li": {
        "&:not(:last-child)": {
          marginRight: theme.spacing(0.5),
        },
      },
    },
  })
);
const CourseBanner: React.FC<CourseBannerProps> = ({ content }) => {
  const classes = useStyle();
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.down("xs"));
  const [open, setOpen] = React.useState(false);
  const togglePopupForm = () => {
    setOpen((prev) => !prev);
  };
  return (
    <>
      <Box className={classes.root} paddingY={[2, 4, 6, 8]} component="section">
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Typography variant="h1" gutterBottom className={classes.heading}>
                {renderHTML(content.heading)}
                <br />
                {/* <span>India, Bangalore</span> */}
              </Typography>
              <Typography gutterBottom className="paragraph">
                {renderHTML(content.paragraph)}
              </Typography>
              <Box marginTop={3}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className="btn-arrow-right"
                  fullWidth={xs}
                  component={Link}
                  to="schedule-section"
                  spy={true}
                  offset={-TOOL_BAR_HEIGHT}
                  duration={500}
                >
                  View Dates & Prices
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  className={classes.requestButton}
                  fullWidth={xs}
                  onClick={togglePopupForm}
                >
                  Download Brochure
                </Button>
              </Box>
              <Grid item xs={12} sm={6} md={8} lg={8}>
                <ul className={classes.logoList}>
                  {content.accreditations?.map((item, index) => (
                    <li key={`acc-` + index}>
                      {item.accreditationLink ? (
                        <a href={item.accreditationLink} target="_new">
                          <Image
                            src={
                              process.env.NEXT_PUBLIC_ADMIN_URL +
                              "storage/images/" +
                              item.imageUrl
                            }
                            width={150}
                            height={70}
                            alt={item.imageAlt}
                            quality={100}
                          />
                        </a>
                      ) : (
                        <Image
                          src={
                            process.env.NEXT_PUBLIC_ADMIN_URL +
                            "storage/images/" +
                            item.imageUrl
                          }
                          width={150}
                          height={70}
                          alt={item.imageAlt}
                          quality={100}
                        />
                      )}
                    </li>
                  ))}
                </ul>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              className={classes.heroImage}
            >
              <Image
                src={
                  process.env.NEXT_PUBLIC_ADMIN_URL +
                  "storage/images/" +
                  content.imageUrl
                }
                width={400}
                height={250}
                style={{ width: "100%", height: "auto" }}
                alt={content.imageAlt}
                priority
              />
            </Grid>
          </Grid>
        </Container>
        <FormDialog
          title="Download Brochure"
          open={open}
          onClose={togglePopupForm}
        >
          <DownloadBrochureForm serviceId={content.serviceId} />
        </FormDialog>
      </Box>
      <OgImage
        src={
          process.env.NEXT_PUBLIC_ADMIN_URL +
          "storage/images/" +
          content.imageUrl
        }
      />
      {/* Breadcrumbs */}
      <Breadcrumbs data={content.breadcrumbs} />
    </>
  );
};

export default CourseBanner;
